// extracted by mini-css-extract-plugin
export var expanded = "TopNavLanguageSelector-module--expanded--8c09a";
export var languageList = "TopNavLanguageSelector-module--language-list--5ae20";
export var listWrapper = "TopNavLanguageSelector-module--list-wrapper--cf6d6";